module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/evie-shaffer-avatar-1af6be4973428a377315ef56d3617796.jpg";